/* TRIMSOUL - newsletter bottom sheet. Opens once per visitor after a delay. */
(function () {
  'use strict';

  var TS = window.TRIMSOUL;

  function storageGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      /* private mode or storage disabled: the popup simply shows again next visit */
    }
  }

  function start() {
    if (!TS || typeof TS.qs !== 'function') {
      return;
    }
    var popup = TS.qs('[data-popup]');
    if (!popup) {
      return;
    }

    var key = popup.getAttribute('data-popup-key') || 'trimsoul-updates-seen';
    var delay = parseInt(popup.getAttribute('data-popup-delay'), 10);
    if (isNaN(delay) || delay < 0) {
      delay = 4000;
    }

    var alreadyShown = storageGet(key) === '1';
    var formJustSubmitted = window.location.hash === '#contact_form';
    var isOpen = false;

    function open() {
      if (isOpen) {
        return;
      }
      isOpen = true;
      storageSet(key, '1');

      popup.hidden = false;
      document.body.classList.add('is-locked');

      var field = popup.querySelector('.popup__email');
      var close = popup.querySelector('.popup__close');
      var target = field || close;
      if (target) {
        target.focus();
      }
    }

    function close() {
      if (!isOpen) {
        return;
      }
      isOpen = false;
      popup.hidden = true;
      document.body.classList.remove('is-locked');
    }

    popup.querySelectorAll('[data-popup-close]').forEach(function (element) {
      element.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (event) {
      if (!isOpen) {
        return;
      }
      if (event.key === 'Escape' || event.key === 'Esc') {
        close();
      }
    });

    if (formJustSubmitted) {
      /* the customer form posts back to this page, show the result straight away */
      open();
    } else if (!alreadyShown) {
      window.setTimeout(open, delay);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
